import "./Services.css";

export default function Services() {
  return (
    <section id="services" className="services">

      <h2 className="title">Our Services</h2>

      <div className="services-container">

        <div className="card">
          <div className="icon">💎</div>
          <h3>Sell Gold</h3>
          <p>
            Get instant cash for your gold with best market value and secure process.
          </p>
        </div>

        <div className="card">
          <div className="icon">🔒</div>
          <h3>Release Pledged Gold</h3>
          <p>
            Easily release your pledged gold from banks and NBFCs with our help.
          </p>
        </div>

        <div className="card">
          <div className="icon">📦</div>
          <h3>Stone Value</h3>
          <p>
            We analyze your stones and provide additional value along with gold.
          </p>
        </div>

        <div className="card">
          <div className="icon">💰</div>
          <h3>We Pay Interest</h3>
          <p>
            We help clear your gold loans including interest from financial institutions.
          </p>
        </div>

      </div>

    </section>
  );
}